import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IFundAccountToken {
  /**
   * 资金账号登录 token
   *
   * @type {string}
   * @memberof IFundAccountToken
   */
  accessToken: string
}

interface IFundAccountTokenResponse {
  success?: (result: IFundAccountToken) => void
  fail?: (result: IFundAccountToken) => void
  complete?: (result: IFundAccountToken) => void
}

/**
 * 获取资金账号登录 token
 * @param cb
 * result -> {'accessToken': '******'}
 *
 */
function getUserFundAccountTokenSync({
  success,
  fail,
  complete
}: IBridgeOptions<IFundAccountTokenResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getAccessToken'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getUserFundAccountTokenSync error: ', error)
  }
}

/**
 * 获取资金账号登录 token<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<IFundAccountToken>}
 */
function getUserFundAccountToken(): Promise<IFundAccountToken> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getAccessToken'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getUserFundAccountToken, getUserFundAccountTokenSync }
